import { Component, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseInfoComponent } from "./base-info.component";
import { DatasourceService } from '@app/core/services';
import { Router } from '@angular/router';
import * as moment from 'moment'


@Component({
  selector: 'customer-info',
  styleUrls: ['./styles/styles-info.css'],
  styles: [`
    .card {
      height: auto;
      border: rgba(0, 0, 0, 0.08) 1px solid;
    }
    .card-details {
      width: 75%;
    }
    .card-status {
      text-align: center;
      padding-bottom: 12px;
    }
    .card-status > div {
      color: white; 
      background-size: contain; 
      padding: 4px; 
      text-align: center; 
    }
    .card-status > img {
      width: 48px;
    }
    .k-block {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 80px;
      border-color: transparent;
    }
    .section-title {
      padding-top: 8px;
      padding-bottom: 4px;
    }
    .section-payment {
      background-color: #ecf0f1;
      display: block;
      width: 100% !important;
      padding: 4px 0;
      // text-align: center;
      margin-top: 4px;
      min-height: 18px;
    }
    .section-separator {
      background-color: #ecf0f1;
      display: block;
      width: 100% !important;
      margin: 8px 0;
      min-height: 1px;
    }
  `],
  template: `
    <!--{{customer | json}}-->
    <div class="k-block" *ngIf="loading">
      <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
    </div>
    <div class="card" *ngIf="!loading">
      <div class="card-details">
        
        <div class="section-payment">
          <label class="k-label">{{ customer.rfc }} - {{ customer.name }}</label> <span class="right">Crédito: {{ customer.credit_days }} días</span>
        </div>

        <div class="section-title">
          <label class="k-label">Resumen: ({{ customer.credit_total }}) créditos</label>
        </div>
        <div class="section-title no-wrap text-primary">
          Por vencer: <span class="right">{{ intl.formatNumber(customer.credit_total_due, "c2") }}</span>
        </div>
        <div class="section-title no-wrap text-danger">
          Vencido: <span class="right">{{ intl.formatNumber(customer.credit_total_overdue, "c2") }}</span>
        </div>

        <div class="section-separator"></div>

        <div class="section-title no-wrap text-danger">
          <span class="right" style="font-size: 24px;">Saldo: {{ intl.formatNumber(customer.credit_total_pending, "c2") }}</span>
        </div>
        
      </div>            
    </div>
  `,    
})
export class CustomerInfoComponent extends BaseInfoComponent {

  //Input: id
  protected _id : number = 0;  

  @Input()
  set id(value: number) {

    this._id = value;
    // this.debug('set table = ' + this._table);
    this.loading = true;

    this.service.getById(this.table, this._id)
      .subscribe(
        (res: any) => {
          // console.log("RESPONSE------: ", res);
          this.customer = res;    

          // //MODIFICAR SI EL ESTATUS ES IGUAL 2 => "POR LIBERAR"
          // if(this.customer.id_vehicle_status == 2){
          //   var a = moment();
          //   var b = moment(this.customer.entry_date);
          //   let days: number = a.diff(b, 'days') + 1;
  
          //   this.customer.days = days;
          //   this.customer.cost_pension = days * parseFloat(this.customer.vehicle_type_fee);
          //   this.customer.cost_subtotal = this.customer.cost_crane + this.customer.cost_pension;
          //   this.customer.cost_iva = this.customer.cost_subtotal * 0.16;
          //   this.customer.cost_total = this.customer.cost_crane + this.customer.cost_pension + this.customer.cost_iva;
          //   this.customer.cost_paid = this.customer.cost_total;
          // }
          
          this.loading = false;                                
          this.complete.emit({dataItem: res});
        },
        (fail: any) => {        
          console.log("Error", fail);
        }
      );

  }

  get id(): number { return this._id; }

  @Input() defaultImage: string = environment.assets.DEFAULT_VEHICLE;

  public table: string = 'customers_credits';

  public customer: any = {};

  public loading: boolean = false;

  @Output() complete = new EventEmitter<{dataItem: any}>();


  constructor(public intl: IntlService, public router: Router, protected service: DatasourceService) { 

    super(intl, router)

  }  

}